<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showConsentimiento"
      no-close-on-backdrop
      title="POLÍTICA, TERMINOS Y CONDICIONES"
      size="lg"
      @hidden="resetModal"
      cancel-variant="outline-secondary"
      hide-header-close
      no-close-on-esc
    >
      <div
        ref="scrollBox"
        style="
    height: 530px;
    overflow-y: auto;
    overflow-x: hidden;
  "
        @scroll="handleScroll"
      >
        <iframe
          :src="`${URL_PDF}consentimiento.html?v=${Math.random() * 100}`"
          style="
      width: 100%;
      height: 7800px; /* más alto que el contenedor */
      border: none;
      display: block;
      overflow: hidden;
    "
        ></iframe>
      </div>

      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col class="mt-1">
              <b-button
                v-if="!spiner"
                :disabled="!canAccept"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="float-right"
                @click="aceptar"
              >
                <span>ACEPTAR Y CONTINUAR</span>
              </b-button>
              <div v-if="spiner" class="text-center mt-1">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { heightFade } from '@core/directives/animations'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import {
  BModal,
  BRow,
  BCol,
  VBPopover,
  BButton,
  BSpinner,
  // xxx,
  // xxxx,
  // xxxx,
  // xxx,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { ref } from '@vue/composition-api'
import { URL_PDF } from '../../utils/variables'

const moment = require('moment-timezone')

moment.tz.setDefault('America/Guayaquil')

const canAccept = ref(false)
export default {
  components: {
    BModal,
    BRow,
    BCol,
    BButton,
    BSpinner,
  },
  directives: {
    'b-popover': VBPopover,
    // 'b-tooltip': VBTooltip,
    heightFade,
    Ripple,
  },
  props: {
    spiner: Boolean,
  },

  setup(props, { emit }) {
    // console.log('setup modal')
    // console.log(props)

    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // emit('recargar', playerSelected.id_equipo)
      // listPlayers.value = []
      // initPlayer()
      //       this.$emit('closeModal', false)
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_CONSENTIMIENTO', false)
    }
    function aceptar() {
      emit('aceptar')
    }
    const handleScroll = event => {
      const el = event.target

      // Si llegó al final del scroll
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 300) {
        canAccept.value = true
      }
    }
    return {
      onlyClose,
      resetModal,
      avatarText,
      handleScroll,
      canAccept,
      aceptar,
      URL_PDF,
    }
  },
}
</script>
<style>
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
.inscrito {
  margin: 0px;
  background: #e6e5e2;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
.calificado {
  margin-top: 10px;
  background: #84ef96;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
</style>
